import React from 'react';
import Signin from './components/Signin';
import LandingPage from './components/LandingPage';
import AdminPanel from './components/AdminPanel';
import Order from './components/Order';
import UploadPhotos from './components/UploadPhotos';
import TerminosPrivacy from './components/TerminosPrivacy';
import { Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div>
      <AuthContextProvider>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/admin' element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
          <Route path="/upload/:id" element={<ProtectedRoute><UploadPhotos /></ProtectedRoute>} />
          <Route path='/order' element={<Order />} />
          <Route path='/terminos' element={<TerminosPrivacy />} />
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default App;
